import { createGQLQuery } from 'graphql/helpers'
import { AddressApiResponse } from 'interfaces/locations'

const SHIPMENT_ADDRESS_QUERY = `
{
  current_user {
    shipment_address {
      number,
      street,
      refinement,
      zip5,
      city {
        id
        name
        state {
          id
          code
        }
      }
    }
  }
}
` as const
type Response = {
  current_user: {
    shipment_address: AddressApiResponse
  }
}
export const gqlCCShipmentAddressQuery = createGQLQuery<typeof SHIPMENT_ADDRESS_QUERY, Response>(SHIPMENT_ADDRESS_QUERY)
